import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { ArtistSearchPage } from '@/features/search/pages/artist-search-page/page';
import { redirectUnauthenticated } from '@/shared/helper';

export const Route = createFileRoute('/artist/$id/_artist/search')({
  validateSearch: z.object({
    countries: z.string().optional() // <- если фильтр строкой
  }),

  beforeLoad: ({ context }) => {
    redirectUnauthenticated(context);
  },

  component: ArtistSearchPage
});
